import { useEffect, useMemo, useState } from "react";

import { useForm } from "react-hook-form";

import { TextInput } from "../shared/Inputs/TextInput";
import Modal, { ModalProps } from "../../layouts/Modal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { ContactCreateEditRequest, IContact } from "../../models/Contact";
import useNotification from "../notifications/useNotifications";
import useContactsMutations from "../../data/useContactsMutations";
import PickAddress from "../shared/Addresses/PickAddress";

interface ContactCreateEditModalProps
  extends Omit<ModalProps, "children" | "width"> {
  contact?: IContact;
  newContactName?: string;
}

export function ContactCreateEditModal({ open, setOpen, contact, newContactName }: ContactCreateEditModalProps) {
  const { register, handleSubmit, reset, setValue, watch } = useForm<ContactCreateEditRequest>();
  const { create: createContact, update: updateContact } = useContactsMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Contact");
  const { addNotification } = useNotification();

  const onSubmit = (data: ContactCreateEditRequest) => {
    console.log(data);
    if (contact) {
      updateContact.mutate({ ...contact, ...data },
        {
          ...saveHandlers,
          onSuccess: () => {
            saveHandlers.onSuccess();
            setOpen(false);
          },
        }
      );
    } else {
      if (data.fullname === "") {
        addNotification({
          variant: "warn",
          primaryText: "Please enter a contact name",
        });
        return;
      }

      createContact.mutate({ ...data },
        {
          ...saveHandlers,
          onSuccess: () => {
            saveHandlers.onSuccess();
            setOpen(false);
          },
        }
      );
    }
  };

  useEffect(() => {
    if (contact) {
      reset({ ...contact });
    } else {
      reset({
        fullname: newContactName,
        contactType: 0,
      });
    }
  }, [contact, open, reset]);

  return (
    <Modal width="max-w-4xl" open={open} setOpen={setOpen}>
      <h2 className="text-xl font-semibold mb-6">{`${contact ? "Edit" : "Add"
        } Contact`}</h2>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid grid-cols-1 sm:grid-cols-2 gap-4"
      >
        <TextInput label="Full Name" register={register} registerName="fullname" />
        <TextInput label="Email Address" register={register} registerName="email" />

        <TextInput label="Primary Telephone" register={register} registerName="telephone1" />
        <TextInput label="Secondary Telephone" register={register} registerName="telephone2" />

        <PickAddress classes="col-span-2" register={register} setValue={setValue} watch={watch} />

        <ButtonInput
          label="Save"
          isSubmit={true}
          classes="mt-2"
          onClick={undefined}
        />
      </form>
    </Modal>
  );
}
